import { HttpClient } from '@angular/common/http';
import { Injectable, } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PurchaseService {

  constructor(private http: HttpClient) { }

  localAppUrl = environment.localApiUrl;

  //Behavior Subject for Purchase Type
  private purchaseType = new BehaviorSubject('');

  getPurchaseType(): Observable<any> {
    return this.purchaseType.asObservable();
  }

  setPurchaseType(type) {
    this.purchaseType.next(type);
  }

  //Behavior Subject for Purchase Field
  private purchaseField = new BehaviorSubject('');

  getPurchaseField(): Observable<any> {
    return this.purchaseField.asObservable();
  }

  setPurchaseField(field) {
    this.purchaseField.next(field);
  }

  // getAllPurchaseTemplates() {
  //   return this.http.get<any>(this.localAppUrl + 'allPurchaseTemplates')
  //     .toPromise()
  //     .then(res => res);
  // }
  
  editPurchaseType(c) {
    return this.http.put<any>(this.localAppUrl + 'allPurchaseTypes', c)
      .toPromise()
      .then(res => res);
  }
  // constructor(private http: HttpClient) { }

  getAllPurchaseStages() {
    return this.http.get<any>(this.localAppUrl + 'allPurchaseStages')
        .toPromise()
        .then(res => res);
  }
  editPurchaseStage(c) {
    return this.http.put<any>(this.localAppUrl + 'allPurchaseStages', c)
        .toPromise()
        .then(res => res);
  }
  getAllPurchaseStatus() {
    return this.http.get<any>(this.localAppUrl + 'allPurchaseStatus')
        .toPromise()
        .then(res => res);
  }

  getAllPurchaseTemplates() {
    return this.http.get<any>(this.localAppUrl + 'allPurchaseTemplates')
        .toPromise()
        .then(res => res);
  }
  editPurchaseTemplate(c) {
    return this.http.put<any>(this.localAppUrl + 'allPurchaseTemplates', c)
      .toPromise()
      .then(res => res);
  }

  getAllTypes() {
    return this.http.get<any>(`${environment.appOrgUrl}Type`)
  }
}
